class BannerClaims {
  constructor(section) {
    this.section = section;
    this.track = section.querySelector('.banner-claims__track-inner');
    this.isAnimated = section.classList.contains('banner-claims--animated');
    this.speedDesktop = parseInt(section.dataset.animationSpeedDesktop) || 40;
    this.speedMobile = parseInt(section.dataset.animationSpeedMobile) || 20;
    this.breakpoint = 990;

    if (this.isAnimated && this.track) {
      this.init();
    }
  }

  init() {
    this.updateSpeed();
    this.handleResize();
  }

  getSpeed() {
    return window.innerWidth >= this.breakpoint ? this.speedDesktop : this.speedMobile;
  }

  updateSpeed() {
    const speed = this.getSpeed();
    this.track.style.setProperty('--animation-duration', `${speed}s`);
  }

  handleResize() {
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        this.updateSpeed();
      }, 100);
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-section-type="banner-claims"]');
  sections.forEach(section => new BannerClaims(section));
});

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-section-type="banner-claims"]');
    if (section) {
      new BannerClaims(section);
    }
  });
}
